import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["beforeFinish", "children"];
import { useContext } from 'react';
import emptyFunction from 'react-utils/emptyFunction';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import handleCallback from '../lib/handleCallback';
import TourContext from '../contexts/TourContext';
import { jsx as _jsx } from "react/jsx-runtime";
const UITourFinishButton = props => {
  const {
    tour
  } = useContext(TourContext);
  const {
      beforeFinish = emptyFunction,
      children = /*#__PURE__*/_jsx(FormattedMessage, {
        message: "shepherd-react.finish"
      })
    } = props,
    buttonProps = _objectWithoutPropertiesLoose(props, _excluded);
  const {
    finish,
    getTour,
    getStep
  } = tour;
  const handleClick = event => {
    if (props.onClick) {
      props.onClick(event);
    }
    handleCallback(beforeFinish, finish, {
      tourKey: getTour(),
      stepKey: getStep()
    });
  };
  return /*#__PURE__*/_jsx(Button, Object.assign({}, buttonProps, {
    onClick: handleClick,
    children: children
  }));
};
export default UITourFinishButton;